/*
 * @Author: crazycattle
 * @Date: 2022-01-07 11:56:15
 * @Description: content
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCookie from 'vue-cookie'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import {axios,fetchGet, fetchPost} from "./assets/js/http"

Vue.use(VueI18n)
Vue.use(VueCookie)
Vue.use(ElementUI, { zhLocale });

Vue.prototype.post = fetchPost
Vue.prototype.get = fetchGet
Vue.prototype.APIPRODUCTBRANCH = 'BLH2018'

router.beforeEach((to, from, next) => {
    if(localStorage.getItem('userInfo') || to.name == 'login'){
        next()
    }else{
        next({ path: '/login' })
    }
})

function InitLanguage() {
    window.localStorage.setItem('lang',window.location.host.indexOf('kidcastleapp.tw') == -1 ? 0 : 1)
    return window.location.host.indexOf('kidcastleapp.tw') == -1 ? 'zh-CN' : 'zh-TW'
    // if(localStorage.getItem('lang')){
    //     return localStorage.getItem('lang')==0?'zh-CN':'zh-TW'
    // }
    // localStorage.setItem('lang',0)
    // return 'zh-CN'
}

const i18n = new VueI18n({
    messages: {
        'zh-CN': Object.assign(require("../static/lang/zh-CN"), zhLocale),
        'zh-TW': Object.assign(require("../static/lang/zh-TW"), twLocale)
    }
});

locale.i18n((key, value) => i18n.t(key, value));

Vue.config.productionTip = false

/* eslint-disable no-new */
let vue = new Vue({
    el: '#app',
    router,
    i18n,
    components: {App},
    template: '<App/>',
    data() {
        return {
            // 自定义事件
            myEvent: new Vue()
        }
    }
})

vue.$i18n.locale = InitLanguage()

export default vue



// WEBPACK FOOTER //
// ./src/main.js